import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

import Home from '@/pages/Home';
import Services from '@/pages/Services';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import HearthProject from '@/pages/HearthProject';
import RealEstatePartners from '@/pages/RealEstatePartners';
import ServiceDetail from '@/pages/ServiceDetail';
import CityPage from '@/pages/CityPage';
import Blog from '@/pages/Blog';
import BlogPost from '@/pages/BlogPost';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import Sop from '@/pages/Sop';
import NotFound from '@/pages/NotFound';

import '@/App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' in window ? 'auto' : 'auto' });
  }, [pathname]);
  return null;
}

function ChromeWrapper({ children }) {
  const { pathname } = useLocation();
  const isInternal = pathname.startsWith('/internal');
  if (isInternal) {
    return <main className="flex-1">{children}</main>;
  }
  return (
    <>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </>
  );
}

const SERVICE_SLUGS = [
  'junk-removal',
  'property-cleanouts',
  'estate-cleanouts',
  'appliance-removal',
  'furniture-removal',
  'debris-removal',
  'yard-waste-removal',
  'donation-recovery',
];

const CITY_SLUGS = [
  'columbus-in-estate-cleanouts',
  'columbus-in-junk-removal',
  'seymour-in-property-cleanouts',
  'bartholomew-county-junk-removal',
  'franklin-in-estate-cleanouts',
  'greenwood-in-junk-removal',
  'edinburgh-in-property-cleanouts',
  'shelbyville-in-junk-removal',
  'north-vernon-in-estate-cleanouts',
  'greensburg-in-property-cleanouts',
];

function App() {
  return (
    <div className="min-h-screen flex flex-col bg-ohana-bg text-ohana-text">
      <BrowserRouter>
        <ScrollToTop />
        <ChromeWrapper>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/hearth-project" element={<HearthProject />} />
            <Route path="/real-estate-partners" element={<RealEstatePartners />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/internal/sop" element={<Sop />} />
            {SERVICE_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<ServiceDetail />} />
            ))}
            {CITY_SLUGS.map((slug) => (
              <Route key={slug} path={`/${slug}`} element={<CityPage />} />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ChromeWrapper>
        <Toaster
          position="bottom-right"
          toastOptions={{
            classNames: {
              toast:
                'rounded-xl border border-ohana-border bg-white text-ohana-text shadow-xl',
              title: 'font-semibold text-ohana-primary',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
